import { BaseStorage } from '@app/core/service/base-storage';

export class LocalStorageService extends BaseStorage {
  protected createStorage(): void {
    this.storage = window.localStorage;
  }
}
